<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Agregar gasto</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Agregar gasto</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body align-items-center">
      <div class="col" style="max-width: 300px;">
        <div class="md-form">
          <mdb-select
            label="Seleccionar Tipo operación"
            [options]="optionsTipoOpe"
            placeholder="Seleccionar Tipo operación"
            [filterEnabled]="true"
          ></mdb-select>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <mdb-date-picker
            [inline]="true"
            name="fecha"
            [placeholder]="'Fecha'"
            required
          ></mdb-date-picker>
        </div>
      </div>
      <div class="col">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="desc"
            class="form-control"
            placeholder="Descripción"
            required
            #desc
          />
          <label for="desc">Descripción</label>
        </div>
      </div>
    </div>
    <div class="row filtros-body align-items-center">
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="rut"
            class="form-control"
            placeholder="9.999.999-9"
            required
            #rut
          />
          <label for="rut">RUT</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="nombre"
            class="form-control"
            placeholder="Nombre"
            required
            #nombre
          />
          <label for="nombre">Nombre</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="nroDoc"
            class="form-control"
            placeholder="121212"
            required
            #nroDoc
          />
          <label for="nroDoc">Nro. Doc.</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="monto"
            class="form-control"
            placeholder="9.000"
            required
            #monto
          />
          <label for="monto">Monto</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6;"
  >
    <div></div>
    <button size="sm" class="btn btn-sm" mdbBtn type="button" color="success" mdbWavesEffect>
      Agregar gasto
    </button>
  </div>
</div>
